import React from "react";
import { NextFunctionComponent } from "next";
import { RouterProps } from "next/router";
import NoSsr from "@material-ui/core/NoSsr";
import { useFormatMessage } from "@comparaonline/react-intl-hooks";

import { Topbar } from "../../components/Header";
import { CheckoutLayout } from "../common/components/CheckoutLayout";
import { CarDealerForm, CarDealerSuccess, Head } from "./components";
import { FormStatus, FormVariantURLMapper } from "./constants";
interface CarDealerProps {
  router: RouterProps<{
    carDealerName: string;
    massive?: boolean;
    status?: FormStatus;
    carDealerAgentId?: string;
    variant?: string;
  }>;
}
type Variant = FromVariant | undefined;
export const CarDealer: NextFunctionComponent<CarDealerProps> = ({ router }) => {
  if (!router.query) {
    return null;
  }

  const t = useFormatMessage();
  const { carDealerName, carDealerAgentId, massive, status, variant } = router.query;

  const mappedFriendlyVariantName = (variant
    ? FormVariantURLMapper[variant]
    : undefined) as Variant;

  const mainContent =
    status === FormStatus.Success ? (
      <CarDealerSuccess carDealerName={carDealerName} />
    ) : (
      <NoSsr>
        <CarDealerForm
          carDealerName={carDealerName}
          carDealerAgentId={carDealerAgentId}
          massive={massive !== undefined}
          variant={mappedFriendlyVariantName}
        />
      </NoSsr>
    );

  return (
    <>
      <Head />
      <Topbar showMenu={false} />
      <CheckoutLayout
        mainContent={mainContent}
        showTitles={true}
        subtitle={t("carDealer.subtitle")}
        title={t("carDealer.title")}
      />
    </>
  );
};
